function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Dialog, Listbox, Transition } from '@headlessui/react';
import { Fragment, useState } from 'react';
import { Helmet } from 'react-helmet';
import img from '../assets/experiences.png';
import { CaretRight } from './components/caret-right';
import { Checkmark } from './components/checkmark';
import { Close } from './components/close';
import { Spinner } from './components/spinner';
export var AVAILABLE_PLANS = {
  '100': {
    maxAttendees: 100,
    startingPrice: 1490
  },
  '500': {
    maxAttendees: 500,
    startingPrice: 4990
  },
  '1000': {
    maxAttendees: 1000,
    startingPrice: 9490
  },
  '2000': {
    maxAttendees: 2000
  },
  '3000': {
    maxAttendees: 3000
  },
  '5000': {
    maxAttendees: 5000
  },
  '7500': {
    maxAttendees: 7500
  },
  '10000': {
    maxAttendees: 10000
  }
};
var plans = Object.keys(AVAILABLE_PLANS).reduce(function (plans, key) {
  var maxAttendees = AVAILABLE_PLANS[key].maxAttendees;
  plans.push({
    label: maxAttendees.toString(),
    value: key
  });
  return plans;
}, []);
export var UpgradeDialog = function UpgradeDialog(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      translations = _ref.translations,
      options = _ref.options,
      lead = _ref.lead;

  var _useState = useState('100'),
      _useState2 = _slicedToArray(_useState, 2),
      selectedPlan = _useState2[0],
      setSelectedPlan = _useState2[1];

  var planDetails = AVAILABLE_PLANS[selectedPlan];
  var contactSales = planDetails.maxAttendees > 1000;

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isNavigating = _useState4[0],
      setIsNavigating = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showGenericError = _useState6[0],
      setShowGenericError = _useState6[1];

  var handleClose = function handleClose() {
    setShowGenericError(false);
    onClose();
  };

  var handleCallToActionClick = function handleCallToActionClick() {
    if (isNavigating) return;

    if (contactSales) {
      if (typeof ChiliPiper === 'undefined') {
        setShowGenericError(true);
        return;
      }

      ChiliPiper.submit('hopin', 'ecomm-subscription', {
        map: true,
        lead: {
          FirstName: lead.firstName,
          LastName: lead.lastName,
          Email: lead.email,
          Company: lead.organisationName,
          desired_attendee_limit__c: selectedPlan,
          of_adming_seats__c: '',
          of_lead_retrieval_licenses__c: '',
          conversion_source__c: 'Free Trial PQL'
        },
        onError: function onError() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          console.error('error', args);
          setShowGenericError(true);
        },
        onClose: onClose
      });
      return;
    }

    setIsNavigating(true);
    window.location.assign("".concat(options.host, "/checkout/").concat(options.organisationId, "?plan=events_ecommerce_").concat(planDetails.maxAttendees, "_annual&currency_locale=en-US&utm_source=").concat(options.source));
  };

  return _jsxs(_Fragment, {
    children: [_jsx(Helmet, {
      children: _jsx("script", {
        src: "https://js.chilipiper.com/marketing.js",
        type: "text/javascript",
        async: true
      })
    }), _jsx(Dialog, {
      open: isOpen,
      onClose: handleClose,
      className: "relative z-50",
      "data-style-hook": "upgrade-dialog",
      children: _jsx("div", {
        className: "fixed inset-0 flex w-screen items-center justify-center bg-gray-800/30",
        children: _jsx(Dialog.Panel, {
          className: "max-w-3xl rounded-xl bg-white p-4 shadow-lg",
          "data-style-hook": "upgrade-dialog-panel",
          children: _jsxs("div", {
            className: "grid grid-cols-2 gap-8",
            children: [_jsxs("div", {
              children: [_jsx(Dialog.Title, {
                className: "mb-4 text-xs leading-relaxed text-gray-600",
                children: translations['upgrade-plan']
              }), _jsx(Dialog.Description, {
                className: "mb-2 text-xl font-medium",
                children: translations['choose-a-perfect-plan']
              }), _jsx("p", {
                className: "text-sm",
                children: translations['select-how-many-attendees']
              }), _jsx("label", {
                htmlFor: "attendees-per-event",
                className: "mb-1 mt-4 block text-sm text-gray-700",
                children: translations['attendees-per-event']
              }), _jsx("div", {
                "data-style-hook": "upgrade-dialog-plan-list",
                className: "relative",
                children: _jsxs(Listbox, {
                  value: selectedPlan,
                  onChange: setSelectedPlan,
                  children: [_jsxs(Listbox.Button, {
                    id: "attendees-per-event",
                    className: "relative w-full cursor-pointer rounded border border-gray-300 bg-white py-2 pl-3 pr-10 text-left font-inter text-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:cursor-not-allowed disabled:bg-gray-200",
                    children: [planDetails.maxAttendees, _jsx(CaretRight, {
                      className: "pointer-events-none absolute inset-y-[0.666rem] right-2 w-4 rotate-90 text-gray-400"
                    })]
                  }), _jsx(Transition, {
                    as: Fragment,
                    leave: "transition ease-in duration-100",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: _jsx(Listbox.Options, {
                      "data-style-hook": "upgrade-dialog-plan-options",
                      className: "absolute top-10 z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-xs shadow-lg ring-1 ring-black/5 focus:outline-none",
                      children: plans.map(function (plan) {
                        return _jsx(Listbox.Option, {
                          "data-style-hook": "upgrade-dialog-plan-option",
                          value: plan.value,
                          className: function className(_ref2) {
                            var active = _ref2.active;
                            return "relative cursor-default select-none py-2 pl-10 pr-4 text-sm text-gray-900 ".concat(active ? 'bg-gray-100' : '');
                          },
                          children: function children(_ref3) {
                            var selected = _ref3.selected;
                            return _jsxs(_Fragment, {
                              children: [_jsx("span", {
                                className: "block truncate ".concat(selected ? 'font-medium' : 'font-normal'),
                                children: plan.label
                              }), selected ? _jsx("span", {
                                className: "absolute inset-y-0 left-0 flex items-center pl-3",
                                children: _jsx(Checkmark, {
                                  className: "h-4",
                                  "aria-hidden": "true"
                                })
                              }) : null]
                            });
                          }
                        }, "option_".concat(plan.value));
                      })
                    })
                  })]
                })
              }), _jsx("p", {
                className: "my-8 flex flex-col items-center",
                children: contactSales ? _jsx("span", {
                  className: "text-3xl",
                  children: translations['lets-discuss']
                }) : _jsxs(_Fragment, {
                  children: [' ', _jsx("span", {
                    className: "text-sm",
                    children: translations['starts-at']
                  }), _jsx("span", {
                    className: "my-1 text-3xl font-medium",
                    children: formatCurrency(planDetails.startingPrice, 'USD')
                  }), _jsx("span", {
                    className: "text-sm",
                    children: translations['per-license-per-year']
                  })]
                })
              }), showGenericError ? _jsx("p", {
                className: "mb-2 text-sm text-red-600",
                children: translations['generic-error']
              }) : null, _jsxs("button", {
                className: "mb-2 mt-6 flex h-10 w-full items-center justify-center rounded-lg bg-primary px-4 text-sm font-medium text-white transition duration-200 ease-in-out hover:bg-blue-600 disabled:cursor-not-allowed disabled:bg-gray-650",
                onClick: handleCallToActionClick,
                type: "button",
                disabled: isNavigating || showGenericError,
                children: [isNavigating ? _jsx(Spinner, {
                  className: "mr-2",
                  label: "Loading"
                }) : null, contactSales ? translations['contact-sales'] : translations['buy-now']]
              })]
            }), _jsxs("div", {
              "data-style-hook": "upgrade-dialog-slides",
              className: "relative flex h-full flex-col rounded-xl bg-[#0684BC] p-4 text-white",
              children: [_jsxs("button", {
                className: "z-20 mb-2 cursor-pointer self-end bg-transparent text-white",
                onClick: handleClose,
                children: [_jsx(Close, {
                  className: "h-4 w-4"
                }), _jsx("span", {
                  className: "sr-only",
                  children: translations['close']
                })]
              }), _jsx("svg", {
                className: "absolute right-0 top-0 h-full",
                viewBox: "0 0 187 388",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: _jsx("circle", {
                  opacity: "0.1",
                  cx: "485",
                  cy: "154.001",
                  r: "485",
                  fill: "white"
                })
              }), _jsx("img", {
                src: img,
                alt: "",
                className: "mx-auto mb-6 w-[90%]"
              }), _jsx("h2", {
                className: "justify-end font-medium",
                children: translations['slides'][0].title
              }), _jsx("p", {
                className: "mt-1 text-xs leading-relaxed",
                children: translations['slides'][0].subtitle
              })]
            })]
          })
        })
      })
    })]
  });
};

function formatCurrency(amount, currency) {
  /* TODO: make the locale dynamic base on the currency_locale */
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency
  }).format(amount);
}